/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UpdateInstallationRequestInstallation } from './UpdateInstallationRequestInstallation';
import {
    UpdateInstallationRequestInstallationFromJSON,
    UpdateInstallationRequestInstallationFromJSONTyped,
    UpdateInstallationRequestInstallationToJSON,
} from './UpdateInstallationRequestInstallation';

/**
 * 
 * @export
 * @interface UpdateInstallationRequest
 */
export interface UpdateInstallationRequest {
    /**
     * Array of field paths specifying which fields to update. Each path must have a corresponding value in the `installation` object. A field included in `installation` but not listed here will be ignored. Allowed values:
     * - `connectionId` - switch the SaaS connection tied to this installation.
     * - `config.createdBy` - change the attribution for who created this config.
     * - `config.content.read.objects.<objectName>` - replace the read config for a single object (e.g. `config.content.read.objects.contacts`).
     * - `config.content.write.objects.<objectName>` - replace the write config for a single object.
     * - `config.content.write.objects` - replace the entire write objects map.
     * - `config.content.subscribe.objects.<objectName>` - replace the subscribe config for a single object.
     * - `config.content.subscribe.objects` - replace the entire subscribe objects map.
     * - `config.content.subscribe.providerOptions` - replace subscribe-level provider options, including `useSalesforceFlows`.
     * - `config.content.proxy.enabled` - enable or disable the proxy.
     * 
     * Replace `<objectName>` with the provider object name (e.g. `contacts`, `leads`, `accounts`).
     * @type {Array<string>}
     * @memberof UpdateInstallationRequest
     */
    updateMask: Array<string>;
    /**
     * 
     * @type {UpdateInstallationRequestInstallation}
     * @memberof UpdateInstallationRequest
     */
    installation: UpdateInstallationRequestInstallation;
}

/**
 * Check if a given object implements the UpdateInstallationRequest interface.
 */
export function instanceOfUpdateInstallationRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "updateMask" in value;
    isInstance = isInstance && "installation" in value;

    return isInstance;
}

export function UpdateInstallationRequestFromJSON(json: any): UpdateInstallationRequest {
    return UpdateInstallationRequestFromJSONTyped(json, false);
}

export function UpdateInstallationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateInstallationRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'updateMask': json['updateMask'],
        'installation': UpdateInstallationRequestInstallationFromJSON(json['installation']),
    };
}

export function UpdateInstallationRequestToJSON(value?: UpdateInstallationRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'updateMask': value.updateMask,
        'installation': UpdateInstallationRequestInstallationToJSON(value.installation),
    };
}

